import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import '../../styles/RejectModal.css';

const RejectModal = ({ isOpen, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason);
      setReason('');
    }
  };

  const handleCancel = () => {
    setReason('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Motif du rejet</h3>
          <button className="close-btn" onClick={handleCancel}>
            <FiX />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="reason">Motif</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Tapez ici..."
              rows={4}
              required
            />
          </div>
          
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel}>
              Annuler
            </button>
            <button type="submit" className="btn-confirm">
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RejectModal;